module.exports = __webpack_public_path__ + "img/sw-logo-md.0b5179a8.webp";